export default "__VITE_ASSET__BwnfsKAD__"